import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Accordion from './accordion.component'
import { connect } from 'react-redux'
import { PRIMARY_COLOR } from '../../styles/colors.style'

const StyledAccordionSteps = styled.div`
	cursor: pointer;
	.accordion {
		&-item {
			margin-bottom: 1.5rem;

			&.open .accordion-item {
				&-header {
					margin-bottom: 2rem;
					border-bottom: 1px solid ${PRIMARY_COLOR};
					line-height: 2em;

					&-title {
						color: ${PRIMARY_COLOR};
					}

					&-icon {
						color: ${PRIMARY_COLOR};
					}
				}
			}

			&:hover:not(.open) .accordion-item {
				&-header {
					&-title {
						color: ${PRIMARY_COLOR};
					}

					&-icon {
						color: ${PRIMARY_COLOR};
					}
				}
			}

			&-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding-bottom: 1rem;
				border-bottom: 1px solid #dddddd;

				&-title {
					font-size: 3.2rem;
					margin-top: 1rem;
				}

				&-icon {
					font-weight: 600;
					font-size: 3.2rem;
				}
			}
		}
	}
`

/**
 *
 * @param {array} items
 * The items to show as accordion-items. template: { title, content }
 *
 * @param {boolean} arrow
 * Shows the arrow in accordion-item
 *
 * @param {boolean} noClickable
 * Disable the click in accordion-item
 *
 * @param {boolean} noAnimated
 * Disbale animate transitions
 *
 * @param {boolean} multiple
 * Enable multiple items to be open simultaneously
 */
class AccordionSecondary extends PureComponent {
	constructor(props) {
		super(props)
	}

	openAll = () =>
		new Promise((resolve) => this.refs.accordion.openAll().then(resolve))
	openJustTheItem = (index) => this.refs.accordion.openJustTheItem(index)
	render() {
		return (
			<StyledAccordionSteps>
				<Accordion ref={'accordion'} {...this.props} />
			</StyledAccordionSteps>
		)
	}
}

AccordionSecondary.propTypes = {
	items: PropTypes.array.isRequired,
	arrow: PropTypes.bool,
	noClickable: PropTypes.bool,
	noAnimated: PropTypes.bool,
}

export default AccordionSecondary
